module.exports = __webpack_public_path__ + "img/JP.407e7efb.png";